import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { LabelEntityMultiSelect } from '../../../LabelEntityMultiSelect'
import { LABEL_FORM_FIELD_NAME_ENTITY } from '../../LabelForm.constants'

function EntityField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      multi
      Component={FormFieldSelectNG}
      Select={LabelEntityMultiSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Label.EntityFieldPlaceholderKey'),
          },
        },
      }}
      emptyValue={EMPTY_LIST}
      fieldComponentProps={{
        label: `${t('Label.EntityFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={LABEL_FORM_FIELD_NAME_ENTITY}
    />
  )
}

export default EntityField
